<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .recents-tab-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-top: 8px;
    min-height: 0;
  }

  .recents-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .recents-empty {
    @include mixins.body3;
    text-align: center;
    color: colors.get(textGrey);
  }

  .helper-text {
    display: flex;
    align-items: center;
    gap: 8px;
    @include mixins.body4;
    color: colors.get(textDisabledGrey);
    flex-shrink: 0;
    margin-top: 16px;
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import RecentNotification from "./RecentNotification.svelte";
  import { uploadsNotificationsStore } from "./stores";
</script>

<div class="recents-tab-container">
  <div class="recents-content">
    {#if $uploadsNotificationsStore.notifications.length === 0}
      <div class="recents-empty">Recent uploads will be displayed here</div>
    {:else}
      {#each $uploadsNotificationsStore.notifications as upload}
        <RecentNotification {upload} />
      {/each}
    {/if}
  </div>
  <div class="helper-text">
    <Icon class="fa-solid fa-circle-info" size="small" />
    <span
      >Resumes you upload will be processed in the background. You can come back
      later to review the results.</span
    >
  </div>
</div>
